import React, { useState, useEffect, useCallback } from "react";
import Manifesto from "./Manifesto";
import FactoryFarms from "./FactoryFarms";

// Minimal path-based router (no react-router dependency needed).
// "/factoryfarms" renders the factory-farm proposal; everything else is the manifesto homepage.

function normalize(path) {
  return path.replace(/\/+$/, "") || "/";
}

export default function App() {
  const [path, setPath] = useState(normalize(window.location.pathname));

  useEffect(() => {
    const onPop = () => setPath(normalize(window.location.pathname));
    window.addEventListener("popstate", onPop);
    return () => window.removeEventListener("popstate", onPop);
  }, []);

  const navigate = useCallback(
    (to) => {
      const next = normalize(to);
      if (next === path) return;
      window.history.pushState({}, "", next);
      setPath(next);
      window.scrollTo(0, 0);
    },
    [path]
  );

  if (path === "/factoryfarms") {
    return <FactoryFarms onNavigate={navigate} />;
  }
  return <Manifesto onNavigate={navigate} />;
}
